import http from '@core/fetch'

export default {
  privilege: () => http('/p/wedding/Admin/APIMerchantPrivilege/list'),

  violate: body =>
    http('/p/wedding/index.php/admin/APIMerchantGradeRecord/violate_list', {
      body
    })
}
